module.exports = __webpack_public_path__ + "img/crown.64def1c6.png";